module.exports = __webpack_public_path__ + "static/img/54-1.ec57bfc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/54-1.jpg
// module id = CB2z
// module chunks = 0